
import { Component, Vue, Prop } from "vue-property-decorator";
import BookingByPlaceMatchCard from "../bookingByPlaceCard/bookingByPlaceMatchCard.vue";
import ScrollableBanner from "@shared/crm/components/scrollableBanner.vue";

@Component({
  components: {
    BookingByPlaceMatchCard,
    ScrollableBanner
  },
})
export default class MatchesBanner extends Vue {
  @Prop({ required: true, type: Array }) matches!: any[];
  @Prop({ required: true, default: 4 }) limit!: number;
  currentIndex: number = 0;

  private get matchesToShow() {
    return this.matches.slice(0, this.limit);
  }

  private get isDarkMode() {
    return this.$store.state.settings.DarkMode === true;
  }

  mounted() {
    if (!this.isDarkMode) {
      this.generateBlobsByPageHeight();
    }
  }
  
   generateBlobsByPageHeight() {
    this.$nextTick(() => {
      const container = this.$refs.blobsContainer as HTMLElement;
      if (!container) return;

      container.innerHTML = "";

      const topRightBlob = document.createElement("div");
      topRightBlob.className = "blob";
      topRightBlob.style.top = "-100px";
      topRightBlob.style.right = "-100px";
      container.appendChild(topRightBlob);

      const bottomLeftBlob = document.createElement("div");
      bottomLeftBlob.className = "blob";
      bottomLeftBlob.style.bottom = "-100px";
      bottomLeftBlob.style.left = "-100px";
      container.appendChild(bottomLeftBlob);
    });
  }

  async joinBooking(e: any, booking: any) {
    e.preventDefault();

    const url =
      booking.bookingTemplateId !== null &&
      booking.bookingTemplateId !== undefined
        ? "/booking-visual/" +
          booking.id +
          "/" +
          booking.bookingTemplateId +
          "?date=" +
          booking.date
        : "/bookings-byplace?bookingId=" + booking.id + "&date=" + booking.date;

    if (this.$store.state.loggedIn === false) {
      this.$store.commit("openLogin", { backUrl: url });
      return;
    }

    if (
      booking.bookingTemplateId !== null &&
      booking.bookingTemplateId !== undefined
    ) {
      return this.$router.push(url);
    }
    
    this.$emit("open-popup", booking);
  }

}
